import { useCallback, useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetWorkspaceMembers } from '@cbhq/identity-api-hooks/account-management/fetch';

import { useOrganization } from '../../../contexts/OrganizationContext';
import { canManageMembers } from '../utils/canManageMembers';
import { ROUTE_TEAM } from '../utils/constants';

import { MultiLEInviteTray } from './MultiLEInviteTray';
import { SingleLEInviteTray } from './SingleLEInviteTray';

export function Invite() {
  const navigate = useNavigate();
  const location = useLocation();

  const { selectedOrganization } = useOrganization();
  const organizationId = selectedOrganization?.organizationId ?? '';

  const orgMembersData = useGetWorkspaceMembers(
    { organizationId },
    { skip: organizationId.length === 0 },
  );
  const canManage = useMemo(
    () => canManageMembers(orgMembersData?.members?.[0]),
    [orgMembersData?.members],
  );

  useEffect(() => {
    if (orgMembersData?.members != null && !canManage) {
      navigate({ pathname: ROUTE_TEAM, search: location.search }, { replace: true });
    }
  }, [canManage, navigate, location.search, orgMembersData?.members]);

  const handleClose = useCallback(() => {
    navigate({
      pathname: ROUTE_TEAM,
      search: location.search,
    });
  }, [navigate, location.search]);

  const legalEntityCount = (selectedOrganization?.legalEntities ?? []).length;
  const isMultiLE = legalEntityCount > 1;

  return isMultiLE ? (
    <MultiLEInviteTray onClose={handleClose} />
  ) : (
    <SingleLEInviteTray onClose={handleClose} />
  );
}
